import React from "react";

const PastRecordings = () => {
    return(
        <div className="main-div">Past Recordings</div>
    )
}

export default PastRecordings